/**
 * Uniform in-memory table produced by every @sae/io reader.
 *
 * One shape for all source formats (brief Sections 6 and 16.3): columns
 * carry the metadata later blocks depend on (variable labels, value
 * labels, declared user-missing codes, display formats, measurement
 * level, per DAT-02), and cell values are normalized on read:
 * system-missing values, Stata/SAS tagged missings, and declared
 * user-missing codes all become null (brief ING-06). Undeclared
 * sentinel values (a bare -9 or 99 with no missing declaration in the
 * file) are data and pass through untouched; flagging those is the
 * automation layer's job, never a silent recode (brief P3).
 */
export const NO_USER_MISSING = { values: [], ranges: [] };
/** Column lookup by exact name; first match wins. */
export function columnIndex(table, name) {
    return table.columns.findIndex((c) => c.name === name);
}
export function columnByName(table, name) {
    const i = columnIndex(table, name);
    return i >= 0 ? table.columns[i] : undefined;
}
/** Rows as objects keyed by column name (later columns win on the rare
 * duplicate name; duplicates are reported as read issues). */
export function toObjects(table) {
    return table.rows.map((row) => {
        const obj = {};
        table.columns.forEach((c, i) => {
            obj[c.name] = row[i] ?? null;
        });
        return obj;
    });
}
/** True when a value falls in a declared user-missing spec. */
export function isUserMissing(spec, value) {
    for (const v of spec.values) {
        if (v === value)
            return true;
    }
    for (const r of spec.ranges) {
        if (typeof value === 'number' &&
            typeof r.lo === 'number' &&
            typeof r.hi === 'number') {
            if (value >= r.lo && value <= r.hi)
                return true;
        }
        else if (typeof value === 'string' &&
            typeof r.lo === 'string' &&
            typeof r.hi === 'string') {
            if (value >= r.lo && value <= r.hi)
                return true;
        }
    }
    return false;
}
//# sourceMappingURL=types.js.map